import { z } from "zod";
import { AgentKind, AgentRole } from "./enums.js";
/** Claims inside a studio token. Kept tiny; the Agent doc is the source of truth. */
export const StudioTokenClaims = z.object({
    sub: z.string(), // agentId
    k: AgentKind,
    r: AgentRole,
});
/** How the host page hands the token to the embedded studio (postMessage). */
export const EmbedMessage = z.discriminatedUnion("type", [
    z.object({ type: z.literal("mm-sales:token"), token: z.string() }),
    z.object({ type: z.literal("mm-sales:ready") }),
    z.object({ type: z.literal("mm-sales:navigate"), path: z.string() }),
]);
//# sourceMappingURL=auth.js.map